import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi, withXhr } from '@angular/common/http'
import { Configuration as NotificationConfiguration, NotificationServiceApiModule } from '@tradecafe/notification-service-sdk-ng'
import { Configuration as PurchaseOrderConfiguration, PurchaseOrderApiModule } from '@tradecafe/purchase-order-sdk-angular'
import { NgModule } from '@angular/core'
import { BuyersGroupApiService } from 'src/pages/admin/settings/buyers-groups/buyers-groups-item/buyers-groups.service'
import { AccountApiService } from './account'
import { AESApiService } from './aes'
import { AgentApiService } from './ai/agent'
import { CallApiService } from './ai/call'
import { ARReportApiService } from './ar-report'
import { AuditApiService } from './audit'
import { AuthApiService } from './auth'
import { AuthInterceptorService } from './auth-interceptor.service'
import { BusinessTypeApiService } from './business-type'
import { ConsigneesApiService } from './consignees'
import { CostApiService } from './cost/cost'
import { SecondaryCostApiService } from './cost/secondary-cost'
import { CreditNoteApiService } from './credit-note'
import { CreditPoolApiService } from './credit-pool'
import { DealApiService } from './deal'
import { DepartmentApiService } from './department'
import { DocumentApiService } from './document-lib/document'
import { DocumentOverrideApiService } from './document-lib/document-override'
import { DocumentSetApiService } from './document-lib/document-set'
import { EstimateApiService } from './estimate'
import { ExportApiService } from './export'
import { FileApiService, FileUploaderService } from './file'
import { ForexApiService } from './forex'
import { ImportApiService } from './import'
import { InvoiceApiService } from './invoice'
import { LogisticNoteApiService } from './logistic-note'
import { MacropointApiService } from './macropoint'
import { MaerskBookingsApiService } from './maersk-booking'
import { MatchedOfferApiService } from './matched-offer'
import { MessageApiService } from './message'
import { BankAccountApiService } from './metadata/bank-account'
import { CountryApiService } from './metadata/country'
import { CurrencyApiService } from './metadata/currency'
import { CustomTagApiService } from './metadata/custom-tag'
import { PaymentMethodApiService } from './metadata/payment-method'
import { PaymentOriginatorApiService } from './metadata/payment-originator'
import { PaymentReferenceApiService } from './metadata/payment-reference'
import { PricingTermApiService } from './metadata/pricing-term'
import { MontshipBookingApiService } from './montship-booking'
import { NoteApiService } from './note'
import { OfferApiService } from './offer'
import { FormulaPricingApiService } from './formula-pricing'
import { OperationsApiService } from './operations'
import { PackageTrackingApiService } from './package-tracking'
import { PromoTextApiService } from './promo-text'
import { ProductCategoryApiService } from './product/category'
import { FormulaValueApiService } from './product/formula-value'
import { ItemTypeApiService } from './product/item-type'
import { MeasureApiService } from './product/measure'
import { ProductPackagingApiService } from './product/packaging'
import { ProductPrefixApiService } from './product/prefix'
import { ProductApiService } from './product/product'
import { ProductSpecificationApiService } from './product/specification'
import { ProductTypeApiService } from './product/type'
import { ProductSuffixApiService } from './product/suffix'
import { WeightTypeApiService } from './product/weight-type'
import { UsdaApiService } from './product/usda'
import { ProductWrappingApiService } from './product/wrapping'
import { ReceiptApiService } from './receipt'
import { CarrierApiService } from './shipment-routing/carrier'
import { LocationApiService } from './shipment-routing/location'
import { RoutesApiService } from './shipment-routing/routes'
import { SegmentApiService } from './shipment-routing/segment'
import { ShipmentApiService } from './shipment-routing/shipment'
import { ShipmentRateApiService } from './shipment-routing/shipment-rate'
import { TrackingProviderApiService } from './shipment-routing/tracking-provider'
import { TransitTimeApiService } from './shipment-routing/transit-time'
import { UnlocodeApiService } from './shipment-routing/unlocode'
import { SupplierOfferApiService } from './supplier-offer'
import { TableViewApiService } from './table-view'
import { TemplateApiService } from './template'
import { TriggerApiService } from './trigger'
import { UserApiService } from './user'
import { ValidateApiService } from './validate'
import { VendorCreditApiService } from './vendor-credit'
import { environment } from 'src/environments/environment'
import { FutureBidsApiService } from 'src/pages/admin/auction/future-bids/future-bids.service'
import { AutomatedOfferApiService } from './automated-offers'

@NgModule({
  imports: [
    NotificationServiceApiModule.forRoot(() => new NotificationConfiguration({
      basePath: environment.apiUrl + '/notification-service',
    })),
    PurchaseOrderApiModule.forRoot(() => new PurchaseOrderConfiguration({
      basePath: environment.apiUrl + '/purchase-order',
    })),
  ],
  exports: [
    NotificationServiceApiModule,
    PurchaseOrderApiModule,
  ],
  providers: [
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AuthInterceptorService,
      multi: true,
    },
    AccountApiService,
    AuditApiService,
    AuthApiService,
    BusinessTypeApiService,
    CreditNoteApiService,
    CreditPoolApiService,
    DealApiService,
    DepartmentApiService,
    EstimateApiService,
    FileApiService,
    FileUploaderService,
    ForexApiService,
    FutureBidsApiService,
    ImportApiService,
    InvoiceApiService,
    LogisticNoteApiService,
    MacropointApiService,
    MatchedOfferApiService,
    MessageApiService,
    NoteApiService,
    OfferApiService,
    PackageTrackingApiService,
    PromoTextApiService,
    ReceiptApiService,
    SupplierOfferApiService,
    TableViewApiService,
    TemplateApiService,
    MessageApiService,
    TriggerApiService,
    MessageApiService,
    UserApiService,
    VendorCreditApiService,
    // CostTypeApiService,
    CostApiService,
    // FinancialTermApiService,
    SecondaryCostApiService,
    DocumentOverrideApiService,
    DocumentSetApiService,
    DocumentApiService,
    BankAccountApiService,
    CountryApiService,
    CurrencyApiService,
    CustomTagApiService,
    PaymentMethodApiService,
    PaymentOriginatorApiService,
    PaymentReferenceApiService,
    PricingTermApiService,
    ProductCategoryApiService,
    ItemTypeApiService,
    MeasureApiService,
    ProductPackagingApiService,
    ProductPrefixApiService,
    ProductApiService,
    ProductSpecificationApiService,
    ProductTypeApiService,
    ProductSuffixApiService,
    WeightTypeApiService,
    UsdaApiService,
    FormulaPricingApiService,
    ProductWrappingApiService,
    ARReportApiService,
    CarrierApiService,
    LocationApiService,
    RoutesApiService,
    SegmentApiService,
    ShipmentRateApiService,
    ShipmentApiService,
    TrackingProviderApiService,
    TransitTimeApiService,
    UnlocodeApiService,
    ConsigneesApiService,
    MaerskBookingsApiService,
    MontshipBookingApiService,
    OperationsApiService,
    AESApiService,
    ExportApiService,
    FormulaValueApiService,
    ValidateApiService,
    BuyersGroupApiService,
    AgentApiService,
    CallApiService,
    AutomatedOfferApiService,
    provideHttpClient(withXhr(), withInterceptorsFromDi())
  ],
})
export class ApiModule { }
